// `useT()` — the translator hook used everywhere in the actor-facing app.
//
// Returns a function `t` that resolves a `BilingualMessage` to the active
// locale's string. Plain strings pass through unchanged so call-sites can
// freely interleave dynamic content with translated literals:
//
//   const t = useT()
//   <strong>{t(copy.predictive.PREDICTIVE.shout.title)}</strong>
//   <span>{t(`Take #${takeNumber}`)}</span>
//
// The translator is memoized on `locale` so identity is stable across renders
// — important for downstream `useMemo`/`useCallback` deps.

import { type Translator, makeTranslator } from '@ohear/shared'
import { useMemo } from 'react'
import { useLocale } from './locale-context'

export function useT(): Translator {
  const { locale } = useLocale()
  return useMemo(() => makeTranslator(locale), [locale])
}
